import { ModulesManagerService } from "../../Module/modules-manager.service"

export class UsersAdmin {
    private firstName =""
    private lastName =""
    private email =""
    private phoneNumber =""
    private displayPhoneNumber = false
    private language =""
    private society =""
    private isAnonyme =false
    private isActive =false
    private isAdmin =false
    private id =0
    private disconnectTime = 0;
    private cguId =0
    private acceptedAt = 0
    private cguUpToDate =false
    private createdDate = 0
    private lastLogin = 0
    constructor (private manager: ModulesManagerService) { }

    get Id(){
        return this.id
    }

    get DisplayName(){
        return this.firstName + " " + this.lastName
    }

    get CguUpToDate(){
        return this.cguUpToDate
    }

    get CguId(){
        return this.cguId
    }

    get DisplayCreatedDate(){
        return (new Date(this.createdDate))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

    get DisplayLastLogin(){
        return (new Date(this.lastLogin))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

    get DisplayAcceptedAt(){
        return (new Date(this.acceptedAt))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

    get IsAdmin(){
        return this.isAdmin
    }

    get IsActive(){
        return this.isActive
    }

    get IsAnonyme(){
        return this.isAnonyme
    }

    get IsPublicContact(){
        return !this.IsAnonyme && !this.IsActive
    }

    get Language(){
        return this.language
    }

    get PhoneNumber(){
        return this.phoneNumber
    }


    get DisconnectTime(){
        return this.disconnectTime
    }

    get Email(){
        return this.email
    }

    get FirstName(){
        return this.firstName
    }

    get LastName(){
        return this.lastName
    }

    get AccountType(){
        if( this.isAdmin) return this.manager.Trad.Parse("STR_ACCOUNT_TYPE_ADMIN")
        if( this.isActive) return this.manager.Trad.Parse("STR_ACCOUNT_TYPE_ACTIVE")
        if( this.isAnonyme) return this.manager.Trad.Parse("STR_ACCOUNT_TYPE_ANONYME")
        return this.manager.Trad.Parse("STR_ACCOUNT_TYPE_PUBLIC")
    }

    get Society(){
        return this.society
    }

    get DisplayPhoneNumber(){
        return this.displayPhoneNumber
    }

    containValue(value){ 
        let containers =["DisplayName","DisplayCreatedDate","DisplayLastLogin","DisplayAcceptedAt","Language","PhoneNumber","Email","FirstName","LastName","AccountType"];
        for (let container of containers)
            if(this[container].toLowerCase().includes(value.toLowerCase()) ) return true
    
        return false
    }

    navigateTo(){
        this.manager.Navi.navigateTo('admin/user/',{id: this.id})
    }

    hydrate(data){
        for(let [k, v] of Object.entries(data)) {
            switch(k){
                case "DisplayPhoneNumber":
                case "IsAdmin":
                case "IsActive":
                case "IsAnonyme":
                    v =  1==v
                    break
            }
            this[this.manager.Tool.minimilizeFirstChar(k)] = v
        }

    }
}
